import { Component, Input, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { doctype } from 'src/app/util/doctype.enum';

@Component({
  selector: 'app-export-excel',
  templateUrl: './export-excel.component.html',
  styleUrls: ['./export-excel.component.scss']
})
export class ExportExcelComponent implements OnInit {
  @Input() docType: doctype = doctype.fitting;
  @Input() data: any[] = [];
  constructor() { }

  ngOnInit(): void {
   
  }

  export(): void {
    console.log(this.data);
    console.log(this.docType);
    const wb = XLSX.utils.book_new();
    var ws: XLSX.WorkSheet;
    if (this.docType === doctype.fitting) {
      console.log('fitting');
      const newData = this.data.map(d => {
        return { id: d.id, partNumber: d.partNumber, productName: d.productName, desciption: d.description, isPreferred: d.isPreferred };
      });
      ws = XLSX.utils.json_to_sheet(newData);
    } else if (this.docType === doctype.pig) {
      console.log('pig');
      const newData = this.data.map(d => {
        return {  productName: d.productName, 
                  bidirectional: d.bidirectional, 
                  minimumMetal: d.minimumMetal, 
                  operatingTemp: d.operatingTemp, 
                  flowSpeed: d.flowSpeed, 
                  maximumRunLength: d.maximumRunLength,
                  minBendRadiusText: d.minBendRadiusText,
                  partNumber: d.partNumber
                 };
      });
      ws = XLSX.utils.json_to_sheet(newData);  
    } else {
      console.log('closure');
      ws = XLSX.utils.json_to_sheet(this.data);
    }
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
   
    XLSX.writeFile(wb, 'QueryResult.xlsx');
  }

}
